import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { MijnTokensBrowserNavigation } from '../../mijn-tokens-browser.navigation';

@Injectable({ providedIn: 'root' })
export class NameGuard {
    public constructor(private readonly navigation: MijnTokensBrowserNavigation) {}

    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    public canActivate(route: ActivatedRouteSnapshot): boolean {
        const nameAllowed = this.navigation.nameAllowed();
        if (!nameAllowed) {
            this.navigation.toStart();
        }
        return nameAllowed;
    }
}
